import {
  GroupCodesController,
  TextFieldController,
} from '@/components/controls';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
} from '@mui/material';
import { Fragment, useEffect } from 'react';
import { useForm } from 'react-hook-form';

export function SharedMissingPersonEditorDialog({
  share,
  isOpen,
  onClose,
  onDelete,
  isDeleting,
}) {
  const {
    control,
    handleSubmit,
    reset,
    formState: { isSubmitting },
  } = useForm({
    defaultValues: share,
  });

  useEffect(() => {
    reset(share);
  }, [reset, share, isOpen]);

  function handleClose() {
    onClose();
  }

  return (
    <form id="missing-share-editor-form" onSubmit={handleSubmit(onClose)}>
      <Dialog open={isOpen} onClose={handleClose}>
        <DialogTitle>{share?.code ? 'Update share' : 'Share'}</DialogTitle>
        <DialogContent>
          <Stack spacing={2}>
            <DialogContentText>
              Please select the groups you wish to share this missing person
              with and provide a reason.
            </DialogContentText>
            <GroupCodesController
              label="Groups"
              control={control}
              name="groupCodes"
              rules={{ required: 'Required' }}
              types={['SECTOR', 'TEAM']}
            />
            <TextFieldController
              name="reason"
              label="Reason"
              control={control}
              rules={{ required: 'Required' }}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          {!!share?.code && (
            <Fragment>
              <Button color="error" onClick={onDelete} disabled={isDeleting}>
                Delete
              </Button>
              <Box sx={{ flexGrow: 1 }} />
            </Fragment>
          )}
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            form="missing-share-editor-form"
            type="submit"
            disabled={isSubmitting}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </form>
  );
}
